import React, { useState, useEffect } from 'react';
import { Card } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { Link } from 'react-router-dom';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const Gallery = () => {
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(true);

  const loadGallery = async () => {
    try {
      const response = await axios.get(`${API}/gallery`);
      setProjects(response.data);
      setLoading(false);
    } catch (error) {
      console.error('Failed to load gallery:', error);
      setLoading(false);
    }
  };

  useEffect(() => {
    loadGallery();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="min-h-screen pt-20">
      {/* Hero Section */}
      <section className="py-20 bg-[#1A1A1A]">
        <div className="container mx-auto px-4 text-center">
          <h1 className="text-5xl md:text-6xl font-bold text-white mb-6">
            Project <span className="text-[#D4AF37]">Gallery</span>
          </h1>
          <div className="w-20 h-1 bg-[#D4AF37] mx-auto mb-6"></div>
          <p className="text-xl text-gray-300 max-w-3xl mx-auto">
            Explore our portfolio of exceptional residential remodeling projects
          </p>
        </div>
      </section>

      {/* Gallery Grid */}
      <section className="py-20 bg-[#0A0A0A]">
        <div className="container mx-auto px-4">
          {loading ? (
            <div className="text-center py-20">
              <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-[#D4AF37] mx-auto mb-4"></div>
              <p className="text-gray-400">Loading gallery...</p>
            </div>
          ) : projects.length === 0 ? (
            <div className="text-center py-20">
              <h3 className="text-2xl font-semibold text-white mb-4">Gallery Coming Soon</h3>
              <p className="text-gray-400 mb-8">
                We&apos;re currently updating our project gallery with our latest remodeling work.<br />
                Check back soon to see our amazing transformations!
              </p>
              <Link to="/quote">
                <Button className="bg-[#D4AF37] text-black hover:bg-[#B8941F] font-semibold">
                  Get a Quote for Your Project
                </Button>
              </Link>
            </div>
          ) : (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
              {projects.map((project) => (
                <Card 
                  key={project.id} 
                  className="project-card bg-[#1A1A1A] border-gray-800 overflow-hidden group cursor-pointer"
                >
                  <div className="relative h-80 overflow-hidden">
                    <img 
                      src={`${BACKEND_URL}${project.image_url}`}
                      alt={project.title} 
                      className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-[#0A0A0A] via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end">
                      <div className="p-6 w-full">
                        <div className="bg-[#D4AF37] text-black text-xs font-semibold px-3 py-1 rounded-full inline-block mb-2">
                          {project.category}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="p-6">
                    <h3 className="text-xl font-semibold text-white mb-2">{project.title}</h3>
                    <p className="text-gray-400 mb-3">{project.description}</p>
                    <div className="flex justify-between items-center text-sm">
                      <span className="text-[#D4AF37]">{project.location}</span>
                      <span className="text-gray-500">{project.year}</span>
                    </div>
                  </div>
                </Card>
              ))}
            </div>
          )}
        </div>
      </section>
    </div>
  );
};

export default Gallery;